export default __webpack_public_path__ + "static/media/arrow2.e0af1b94.svg";